"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormInputContext = exports.FormInputContext = void 0;
var react_1 = __importDefault(require("react"));
exports.FormInputContext = react_1.default.createContext(undefined);
var useFormInputContext = function () {
    var context = react_1.default.useContext(exports.FormInputContext);
    return context;
};
exports.useFormInputContext = useFormInputContext;
